import { render, staticRenderFns } from "./TemporaryCountingAdd.vue?vue&type=template&id=6281c206&scoped=true"
import script from "./TemporaryCountingAdd.vue?vue&type=script&lang=js"
export * from "./TemporaryCountingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6281c206",
  null
  
)

export default component.exports